export default __webpack_public_path__ + "static/media/Nunito-Light.d9c3d83c.woff";